var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountLogo = function SvgAccountLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.25,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M7 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5M7 9a4 4 0 0 1 3.995 3.8L11 13H3a4 4 0 0 1 4-4"
  }))));
};
export default SvgAccountLogo;